'use client';

import dynamic from 'next/dynamic';
import PageHeader from '@/components/common/PageHeader';

const DynamicComponent3WithNoSSR = dynamic(() => import('../../../components/Asset'), {
  ssr: false,
});

type Props = {
  data: string;
  slug: string;
  menuItemClickedBookingPage?: string;
};

export default function AssetPageClient({ data, slug, menuItemClickedBookingPage }: Props) {
  const {
    title,
    description,
    tourImage,
    website,
    faviconUrl,
    charset,
    fbPixel,
    fbAppId,
    htmlCode
  } = JSON.parse(data);

  return (
    <PageHeader
      title={title}
      description={description}
      slug={slug}
      tourImage={tourImage}
      website={website}
      fbPixel={fbPixel || ''}
      fbAppId={fbAppId || ''}
      faviconUrl={faviconUrl}
      htmlCode={htmlCode || ''}
      type="asset"
      charset={charset}
    >
      <DynamicComponent3WithNoSSR
        matterId={slug}
        menuItemClickedBookingPage={menuItemClickedBookingPage}
        reactAws={process.env.NEXT_PUBLIC_CDN}
        googleKey={process.env.NEXT_PUBLIC_GOOGLE_KEY}
      />
    </PageHeader>
  );
}
